export const getMeinianFilters = () => (sessionStorage.getItem('meinianFilters') === 'undefined' ? [] : (JSON.parse(sessionStorage.getItem('meinianFilters')) || []))
